import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 30,
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return <img className={classes.img} src="/autumngames.png" alt="Autumn Games" />;
};
